export default "__VITE_ASSET__a4e2aa8a__"